import template from './events.html';
import tr from '../../lib/default-translator.js';

class AdminEventsViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_events_help()
	{
		Grape.dialog.open('EventsHelp', {});
	}
}

class AdminEventsPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminEventsViewModel(this);
		document.title = tr('Manage Events');
		window.current_page_title(tr('Add/Edit Events'));
	}
}

export default {
	route: '[/]admin/events',
	page_class: AdminEventsPage,
	template: template,
	template_filename: 'translation/events'
};
